import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import NavbarSection from '../Components/Navbar';

const LayoutContainer = styled.div`
display: flex;
`;

export const Layout = () => (
  <Outlet />
);

export const SidebarLayout = () => (
  <LayoutContainer>
    <NavbarSection />
    <Outlet />
  </LayoutContainer>
);
